import { DatePipe } from "@angular/common";
import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "subscription_date",
})
export class SubscriptionDatePipe implements PipeTransform {
  private datePipe = new DatePipe("en-US");

  transform(value: number | null | undefined): string {
    if (value === null || value === undefined) return "";
    const milliseconds = value * 1000;
    const fixedFormat = "y-MM-dd HH:mm";
    return this.datePipe.transform(milliseconds, fixedFormat) ?? "";
  }
}
